import CustomLottie from '@/components/custom-lottie';
import { LottiesContext } from '@/pages/(gapsdk)/_provider/lotties-provider';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CashSuccess({
  transaction_id,
}: {
  transaction_id: string;
}) {
  const { default: defaultSuccess } = useContext(LottiesContext);

  const navigate = useNavigate();
  const { event } = useContext(SoundContext);
  useEffect(() => {
    event.playPaymentSuccess();
  }, []);

  return (
    <div className="relative flex size-full flex-col items-center bg-success">
      <div className="m-auto flex max-w-[480px] flex-col items-center justify-center gap-6">
        <CustomLottie
          className="size-[180px] overflow-hidden rounded-full border border-solid border-white"
          animationData={defaultSuccess}
          onLoadComplete={() => {
            navigate(`/gift-card/receipt/${transaction_id}`);
          }}
        />
        <h2 className="flex-none text-[32px] font-bold text-white">
          Payment Successful!
        </h2>
      </div>
    </div>
  );
}
